var _g, _g2, _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "process-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.719,
    height: 31.719,
    viewBox: "0 0 31.719 31.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_77_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876",
    transform: "translate(0.661 0.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M25.2,10A15.2,15.2,0,1,1,10,25.2,15.2,15.2,0,0,1,25.2,10Z",
    transform: "translate(-10 -10)",
    fill: "#007cab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    "data-name": "Group 877"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M15.859,31.719A15.859,15.859,0,1,1,31.719,15.859,15.877,15.877,0,0,1,15.859,31.719Zm0-30.4A14.538,14.538,0,1,0,30.4,15.859,14.554,14.554,0,0,0,15.859,1.322Z",
    fill: "none"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_78_",
    transform: "translate(3.304 3.304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_879",
    "data-name": "Group 879",
    transform: "translate(0.661 0.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M83.789,70.243v3.3a.663.663,0,0,1-.661.661H80.842a9.084,9.084,0,0,1-.985,2.379l1.619,1.619a.658.658,0,0,1,0,.932l-2.339,2.339a.658.658,0,0,1-.932,0l-1.619-1.619a9.084,9.084,0,0,1-2.379.985v2.286a.663.663,0,0,1-.661.661h-3.3a.663.663,0,0,1-.661-.661V80.842a9.084,9.084,0,0,1-2.379-.985l-1.619,1.619a.658.658,0,0,1-.932,0l-2.339-2.339a.658.658,0,0,1,0-.932l1.619-1.619a9.084,9.084,0,0,1-.985-2.379H60.661A.663.663,0,0,1,60,73.547v-3.3a.663.663,0,0,1,.661-.661h2.286a9.084,9.084,0,0,1,.985-2.379l-1.619-1.619a.658.658,0,0,1,0-.932l2.339-2.339a.658.658,0,0,1,.932,0L67.2,63.932a9.084,9.084,0,0,1,2.379-.985V60.661A.663.663,0,0,1,70.243,60h3.3a.663.663,0,0,1,.661.661v2.286a9.084,9.084,0,0,1,2.379.985l1.619-1.619a.658.658,0,0,1,.932,0l2.339,2.339a.658.658,0,0,1,0,.932L79.857,67.2a9.084,9.084,0,0,1,.985,2.379h2.286A.663.663,0,0,1,83.789,70.243Z",
    transform: "translate(-60 -60)",
    fill: "#e7eced"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M64.207,75.111H60.9a1.323,1.323,0,0,1-1.322-1.322V72a9.764,9.764,0,0,1-1.6-.663L56.712,72.6a1.319,1.319,0,0,1-1.866,0l-2.339-2.339a1.319,1.319,0,0,1,0-1.866l1.266-1.266a9.755,9.755,0,0,1-.663-1.6H51.322A1.323,1.323,0,0,1,50,64.207V60.9a1.323,1.323,0,0,1,1.322-1.322H53.11a9.763,9.763,0,0,1,.663-1.6l-1.266-1.266a1.319,1.319,0,0,1,0-1.866l2.339-2.339a1.319,1.319,0,0,1,1.866,0l1.266,1.266a9.756,9.756,0,0,1,1.6-.663V51.322A1.323,1.323,0,0,1,60.9,50h3.3a1.323,1.323,0,0,1,1.322,1.322V53.11a9.763,9.763,0,0,1,1.6.663L68.4,52.506a1.319,1.319,0,0,1,1.866,0L72.6,54.846a1.319,1.319,0,0,1,0,1.866l-1.266,1.266a9.756,9.756,0,0,1,.663,1.6h1.788A1.323,1.323,0,0,1,75.111,60.9v3.3a1.323,1.323,0,0,1-1.322,1.322H72a9.764,9.764,0,0,1-.663,1.6L72.6,68.4a1.319,1.319,0,0,1,0,1.866L70.265,72.6a1.319,1.319,0,0,1-1.866,0l-1.266-1.266a9.756,9.756,0,0,1-1.6.663v1.788A1.323,1.323,0,0,1,64.207,75.111Zm-6.344-5.253a.659.659,0,0,1,.337.093,8.432,8.432,0,0,0,2.206.913.661.661,0,0,1,.5.64v2.286h3.3V71.5a.661.661,0,0,1,.5-.64,8.43,8.43,0,0,0,2.206-.913.661.661,0,0,1,.805.1l1.619,1.619L71.67,69.33l-1.619-1.616a.661.661,0,0,1-.1-.8,8.431,8.431,0,0,0,.913-2.206.661.661,0,0,1,.64-.5h2.286V60.9H71.5a.661.661,0,0,1-.64-.5A8.43,8.43,0,0,0,69.95,58.2a.661.661,0,0,1,.1-.805l1.619-1.619L69.33,53.441,67.714,55.06a.661.661,0,0,1-.8.1,8.431,8.431,0,0,0-2.206-.913.661.661,0,0,1-.5-.64V51.322H60.9v2.286a.661.661,0,0,1-.5.64,8.43,8.43,0,0,0-2.206.913.661.661,0,0,1-.805-.1l-1.619-1.619L53.441,55.78,55.06,57.4a.661.661,0,0,1,.1.805,8.431,8.431,0,0,0-.913,2.206.661.661,0,0,1-.64.5H51.322v3.3h2.286a.661.661,0,0,1,.64.5,8.43,8.43,0,0,0,.913,2.206.661.661,0,0,1-.1.805l-1.619,1.619L55.78,71.67,57.4,70.051A.66.66,0,0,1,57.864,69.857Z",
    transform: "translate(-50 -50)",
    fill: "#231f20"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M180.678,243.468l-2.643-2.313-.87.995,1.32,1.155h-3.858a3.308,3.308,0,0,1-3.3-3.3H170a4.631,4.631,0,0,0,4.626,4.626h3.858l-1.32,1.155.87.995,2.643-2.313a.661.661,0,0,0,0-.995Z",
    transform: "translate(-158.766 -224.141)",
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M151.278,139.623h-3.858l1.32-1.155-.87-.995-2.643,2.313a.661.661,0,0,0,0,.995l2.643,2.313.87-.995-1.32-1.155h3.858a3.308,3.308,0,0,1,3.3,3.3H155.9A4.631,4.631,0,0,0,151.278,139.623Z",
    transform: "translate(-135.418 -128.39)",
    fill: "#231f20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 1.964,
    cy: 1.964,
    r: 1.964,
    transform: "translate(13.925 13.925)",
    fill: "#007cab"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.7a83b6853d80f44af75a1324b6765180.svg";
export { ForwardRef as ReactComponent };